import { applyMiddleware, createStore } from 'redux';
import { createBrowserHistory } from 'history';
import { routerMiddleware } from 'connected-react-router';
import { composeWithDevTools } from 'redux-devtools-extension';
import promise from 'redux-promise-middleware';
import thunk from 'redux-thunk';
import { rootReducer } from 'reducers';

export const history = createBrowserHistory();

const composeEnhancers = composeWithDevTools(applyMiddleware(
  routerMiddleware(history),
  promise({
    promiseTypeSuffixes: JSON.parse(
      process.env.REACT_APP_ASYNC_ACTION_TYPES
    ),
    promiseTypeDelimiter: process.env.REACT_APP_PROMISE_TYPE_DELIMITER
  }),
  thunk
));

export default function configureStore() {
  return createStore(
    rootReducer(history),
    composeEnhancers
  );
}
